import { LanguageState, LanguageType } from './state'

export const getLanguage = function (state: LanguageState): LanguageType {
  return state.language
}
